module.exports = __webpack_public_path__ + "img/dsci0069.940ab475.jpg";